import '../css/app.css';
import './bootstrap';

import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createApp, h } from 'vue';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import { initializeTrackingScripts } from './loadtrack';

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

const options = { // TOAST notifications options placeholder
    // You can set your default options here
    timeout: 5000,
};

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.vue`,
            import.meta.glob('./Pages/**/*.vue'),
        ),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue)
            .use(Toast, options);

        app.mount(el);

        // Initialize tracking scripts
        initializeTrackingScripts();
    },
    progress: {
        color: '#4B5563',
    },
});
